import React from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { Row, Col, Form } from "react-bootstrap";
import DatePicker from "react-datepicker";
import Select from "react-select";
import "react-datepicker/dist/react-datepicker.css";

import Modal from "../../modal";
import { isGuid } from "../../../utils/string";

class AvailabilityModal extends React.Component {
    constructor(props) {
        super(props);
        this.state = this.mapPropsToState(props);
    }

    mapPropsToState = (props) => {
        const start = props?.time?.start ?? null;
        const end = props?.time?.end ?? null;

        return {
            uuid: props.uuid ?? null,
            personUuid: props.personUuid ?? null,
            roleUuid: props.roleUuid ?? "",
            date: start ? new Date(start) : new Date(),
            start: start ? new Date(start) : null,
            end: end ? new Date(end) : null,
            meta: props.meta ?? null,
            roles: props.roles ?? [],
        };
    };

    componentDidUpdate(prevProps) {
        if ((!prevProps.show && this.props.show) || prevProps.uuid !== this.props.uuid) {
            this.setState(this.mapPropsToState(this.props));
        }
    }

    isSavable = () => {
        return (
            isGuid(this.state.personUuid) &&
            isGuid(this.state.roleUuid) &&
            this.state.start instanceof Date &&
            !isNaN(this.state.start.getTime()) &&
            this.state.end instanceof Date &&
            !isNaN(this.state.end.getTime()) &&
            this.state.end > this.state.start
        );
    };

    onRoleChange = (opt) => {
        this.setState({ roleUuid: opt?.value ?? "" });
    };

    onStartChange = (date) => {
        this.setState((prev) => {
            let nextEnd = prev.end;
            if (!nextEnd || nextEnd <= date) {
                nextEnd = new Date(date.getTime() + 30 * 60 * 1000);
            }

            return {
                start: date,
                end: nextEnd,
                date,
            };
        });
    };

    onEndChange = (date) => {
        this.setState({ end: date });
    };

    buildPayload = () => ({
        uuid: this.state.uuid,
        personUuid: this.state.personUuid,
        roleUuid: this.state.roleUuid,
        date: this.state.start?.toISOString().slice(0, 10),
        startTime: this.state.start?.toTimeString().slice(0, 8),
        endTime: this.state.end?.toTimeString().slice(0, 8),
        meta: this.state.meta ?? null,
    });

    onOk = () => this.props.onOk?.(this.buildPayload());
    onDelete = () => this.props.onDelete?.({ ...this.buildPayload(), kind: "availability" });
    onCopy = () => this.props.onCopy?.(this.buildPayload());
    onCancel = () => this.props.onCancel?.();

    render() {
        const roleOptions = (this.state.roles || []).map((role) => ({
            value: role.uuid,
            label: role.caption || role.name,
        }));

        const selectedRole = roleOptions.find((x) => x.value === this.state.roleUuid) ?? null;

        return (
            <Modal
                show={this.props.show}
                title={isGuid(this.state.uuid) ? "Edit Availability" : "Create Availability"}
                size={this.props.size || "lg"}
                buttons={[
                    {
                        caption: "copy",
                        onEnabledClick: this.onCopy,
                        variant: "primary",
                        enabled: true,
                        display: isGuid(this.state.uuid),
                    },
                    {
                        caption: "delete",
                        onEnabledClick: this.onDelete,
                        variant: "primary",
                        enabled: true,
                        display: isGuid(this.state.uuid),
                    },
                    {
                        caption: "ok",
                        onEnabledClick: this.onOk,
                        variant: "primary",
                        enabled: this.isSavable(),
                        display: true,
                    },
                    {
                        default: true,
                        caption: "cancel",
                        onEnabledClick: this.onCancel,
                        variant: "secondary",
                        enabled: true,
                        display: true,
                    },
                ]}
            >
                <Row className="g-0 mb-3">
                    <Col>
                        <div className="mb-3 top-label">
                            <Select
                                value={selectedRole}
                                onChange={this.onRoleChange}
                                classNamePrefix="react-select"
                                placeholder="Select role..."
                                options={roleOptions}
                            />
                            <Form.Label>ROLE</Form.Label>
                        </div>
                    </Col>
                </Row>

                <Row className="g-0 mb-3">
                    <Col md="6" className="pe-md-2">
                        <div className="mb-3 top-label">
                            <DatePicker
                                className="form-control"
                                selected={this.state.start}
                                onChange={this.onStartChange}
                                timeIntervals={15}
                                showTimeSelect
                                showTimeInput
                                dateFormat="MMMM d, yyyy h:mm aa"
                            />
                            <Form.Label>START</Form.Label>
                        </div>
                    </Col>

                    <Col md="6" className="ps-md-2">
                        <div className="mb-3 top-label">
                            <DatePicker
                                className="form-control"
                                selected={this.state.end}
                                onChange={this.onEndChange}
                                timeIntervals={15}
                                showTimeSelect
                                showTimeInput
                                dateFormat="MMMM d, yyyy h:mm aa"
                            />
                            <Form.Label>END</Form.Label>
                        </div>
                    </Col>
                </Row>
            </Modal>
        );
    }
}

AvailabilityModal.propTypes = {
    show: PropTypes.bool,
    personUuid: PropTypes.string,
    roles: PropTypes.array,
    onOk: PropTypes.func,
    onDelete: PropTypes.func,
    onCopy: PropTypes.func,
    onCancel: PropTypes.func,
};

export default connect()(AvailabilityModal);